import * as React from 'react';
import { Notification } from '../Notification/Notification';

export interface MessageBannerProps {
  onClose?(): void;
}

export interface MessageBannerState {
  show: boolean;
}

/**
 * Shows a green message banner -see [[Notification]]- when a form has been saved successfully. The banner dissapears after 5 second.
 */
export class MessageBanner extends React.Component<MessageBannerProps, MessageBannerState> {
  static defaultProps = {
    onClose: () => {}
  };

  private _messageBannerDiv: HTMLElement;

  constructor(props: MessageBannerProps) {
    super(props);
    this.state = {
      show: true
    };
  }

  removeMessageBanner = () => {
    if (this.state.show) {
      this._messageBannerDiv.classList.add('message-banner--fadeout');
      setTimeout(() => {
        this.setState(
          {
            show: false
          },
          this.props.onClose
        );
      }, 200);
    }
  }

  componentDidMount() {
    setTimeout(this.removeMessageBanner, 5000);
  }

  public render() {
    return this.state.show ? (
      <div ref={ ref => this._messageBannerDiv = ref } className="message-banner">
        <div className="container">
          <div className="row">
            <div className="col">
              <div className="message-banner__offset">
                <Notification
                  notificationText="Sparad"
                  notificationType={'success'}
                  onCloseCallback={this.removeMessageBanner}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    ) : null;
  }
}
